import FloorPlanComponent from '../room-and-floorplan-modal/room-and-floorplan-modal';

export default FloorPlanComponent;
